var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19C2 19.9693 2.11783 20.618 2.34327 21.0791C2.5502 21.5023 2.88679 21.8473 3.51687 22.1337C4.17962 22.4349 5.14546 22.6599 6.5602 22.8028C7.96536 22.9448 9.74527 23 12 23C14.2547 23 16.0346 22.9448 17.4398 22.8028C18.8545 22.6599 19.8204 22.4349 20.4831 22.1337C21.1132 21.8473 21.4498 21.5023 21.6567 21.0791C21.8822 20.618 22 19.9693 22 19C22 18.0307 21.8822 17.382 21.6567 16.9209C21.4498 16.4977 21.1132 16.1527 20.4831 15.8663C19.8204 15.5651 18.8545 15.3401 17.4398 15.1972C16.0346 15.0552 14.2547 15 12 15C9.74527 15 7.96536 15.0552 6.5602 15.1972C5.14546 15.3401 4.17962 15.5651 3.51687 15.8663C2.88679 16.1527 2.5502 16.4977 2.34327 16.9209C2.11783 17.382 2 18.0307 2 19Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(-1 0 0 1 12 6)",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.691820b872b3fabb9b5c4e101ec7a7ed.svg";
export { ForwardRef as ReactComponent };